
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elections",
      function () {
        return require("private-next-pages/elections/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elections"])
      });
    }
  